import { render, staticRenderFns } from "./ListMaterials.vue?vue&type=template&id=e35e8558&lang=true"
import script from "./ListMaterials.vue?vue&type=script&lang=js"
export * from "./ListMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports